// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discord-user{background:#7289da;display:inline-flex;align-items:center;padding:7px;border-radius:50px}.discord-user img{width:30px;height:30px;border-radius:50px}.discord-user span{margin:0 15px}", ""]);
// Exports
module.exports = exports;
